import { render, staticRenderFns } from "./AiAssistant.vue?vue&type=template&id=b43fcf72&scoped=true&"
import script from "./AiAssistant.vue?vue&type=script&lang=js&"
export * from "./AiAssistant.vue?vue&type=script&lang=js&"
import style0 from "./AiAssistant.vue?vue&type=style&index=0&id=b43fcf72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43fcf72",
  null
  
)

export default component.exports